import React, { useEffect } from "react";
import Layout from "../../../components/vendorManager/Layout";
import Helmet from "react-helmet";
import usePaginate from "../../../hooks/api/usePaginate";
import apiRequest from "../../../utils/vendorManager/apiRequest";
import Pagination from "../../../components/ui/Pagination";
import { useSelector } from "react-redux";
import { FaEye, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { ORDER_DEATILS_PRODUCT_ROUTE } from "../../../routes/vendorManager/vendorRoutes";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import socket from "../../../utils/socket";

/* =========================
   SOCKET DEBUG (GLOBAL)
========================= */
socket.on("connect", () => {
  console.log("🟢 Socket connected:", socket.id);
});

socket.on("disconnect", (reason) => {
  console.log("🔴 Socket disconnected:", reason);
});

socket.on("connect_error", (err) => {
  console.error("❌ Socket connection error:", err.message);
});

const ScanOrder = () => {

  const vendorProfile = useSelector(
    (state) => state.globalState.vendorManagerProfile
  );

  const {
    currentPage,
    data,
    fetchData,
    limit,
    loading,
    setPage,
    totalItems,
    totalPages,
  } = usePaginate({
    apiMethod: apiRequest.getVendorScanOrders,
    dataKey: "orders",
  });

  useEffect(() => {
    console.log("🧾 Vendor Profile:", vendorProfile);

    if (!vendorProfile?.id) {
      console.warn("⚠️ Vendor ID not available yet");
      return;
    }

    console.log("🏷 Joining vendor room:", vendorProfile?.id);
    socket.emit("JOIN_VENDOR", vendorProfile?.id);

    socket.on("NEW_SCAN_PAY_ORDER", (order) => {
      console.log("🔥 SOCKET EVENT RECEIVED:", order);

      toast.success(
        `New Scan Pay Order • Token #${order?.tokenNo ?? "N/A"}`
      );

      console.log("🔄 Refetching scan orders...");
      fetchData(1);
    });

    return () => {
      console.log("🧹 Removing socket listener");
      socket.off("NEW_SCAN_PAY_ORDER");
    };
  }, [vendorProfile?._id]);

  return (
    <Layout>
      <Helmet>
        <title>Scan & Pay Orders</title>
      </Helmet>

      <div className="p-4">
        <h2 className="text-xl font-semibold mb-4">
          Scan & Pay Orders
        </h2>

        {loading && (
          <p className="text-center text-gray-500">
            Loading orders...
          </p>
        )}

        {!loading && data?.length === 0 && (
          <p className="text-center text-gray-500">
            No Scan Pay orders yet
          </p>
        )}

        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-4">
          {data?.map((order) => (
            <OrderCard
              key={order._id}
              order={order}
              fetchData={fetchData}
            />
          ))}
        </div>

        {totalPages > 1 && (
          <Pagination
            pagination={{
              currentPage,
              totalPages,
              totalItems,
              perPage: limit,
            }}
            handlePageChange={setPage}
          />
        )}
      </div>
    </Layout>
  );
};

const OrderCard = ({ order, fetchData }) => {
  const handleApprove = async () => {
    await apiRequest.approveScanOrder({
      id: order._id,
    });
    toast.success("Order Approved");
    fetchData(1);
  };

  const handleReject = async () => {
    await apiRequest.rejectScanOrder({
      id: order._id,
    });
    toast.error("Order Rejected");
    fetchData(1);
  };


  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-100 p-4 relative hover:shadow-lg transition">

      <div className="absolute top-3 right-3 bg-[#fff644] text-black text-xs px-2 py-1 rounded">
        Token <span className="font-bold">#{order.tokenNo}</span>
      </div>

      <h3 className="font-semibold text-lg mb-1">
        ₹{order.totalAmount}
      </h3>

      <p className="text-sm text-gray-600">
        {order.products?.length} items
      </p>

      <p className="text-xs text-gray-500 mt-1">
        {dayjs(order.createdAt).format("DD MMM YYYY, hh:mm A")}
      </p>

      {/* <span
        className={`inline-block mt-2 px-3 py-1 rounded-full text-xs ${order.status === "Pending"
            ? "bg-yellow-100 text-yellow-700"
            : order.status === "Completed"
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
      >
        {order.status}
      </span> */}

      <div className="flex justify-between items-center mt-4">
        {/* <Link
          to={ORDER_DEATILS_PRODUCT_ROUTE(order._id)}
          className="text-blue-600 flex items-center gap-1 text-sm"
        >
          <FaEye /> View
        </Link> */}

        {order.
          orderStatus === "Requested" && (
            <div className="flex  w-[100%] justify-between items-center gap-3">
              <button
                onClick={handleApprove}
                className="flex gap-1 items-center bg-green-500 text-white p-1 rounded-full hover:scale-110 transition"
                title="Approve"
              >
                <FaCheckCircle size={22} /> <span className="pr-1"> Approved</span>
              </button>

              <button
                onClick={handleReject}
                className="text-red-600 hover:scale-110 transition"
                title="Reject"
              >
                <FaTimesCircle size={22} />
              </button>
            </div>
          )}
      </div>
    </div>
  );
};

export default ScanOrder;
